import styled from '@emotion/styled';
import { Divider } from '@kc-console/common-ui';

export default function GnbItemDivider() {
  return <StyledDivider orientation={'vertical'} />;
}

const StyledDivider = styled(Divider)`
  border-color: #13161999;
`;
